import {cookieUtil} from "@nuskin/ns-util";
import {storage} from '@nuskin/ns-util';

/**
 *
 * userProfileManager
 *
 * @namespace userProfileManager
 */
const userProfileManager = (function() {
    // *******************
    // Moved the global variables fro outside to here....
    // and return it outside
    let LEGACY_USER_ROLE = {
        PRIMARY : 'PRIMARY',
        ASSOCIATE : 'ASSOCIATE'
    };
    let USER_ROLE = {
        PRIMARY : 'Primary',
        ASSOCIATE : 'Associate',
        FAMILY_MEMBER : 'FamilyMember'
    };
    let LEGACY_USER_TYPE = {
        RETAIL_CUSTOMER : 'CUST',
        PREFERED_CUSTOMER : 'PREF',
        PREFERED_CUSTOMER_ALT : 'PREFERRED',
        PRIMARY_DISTRIBUTOR : 'DIST',
        ASSOCIATE : 'ASSOC',
        FAMILY_MEMBER : 'FAMILY'
    };
    let USER_TYPE = {
        RETAIL_CUSTOMER : 'Retail_Customer',
        PREFERED_CUSTOMER : 'Prefered_Customer',
        PRIMARY_DISTRIBUTOR : 'Primary_Distributor',
        ASSOCIATE : 'Associate',
        FAMILY_MEMBER : 'FamilyMember'
    };
    let CUST_CLASS = {
        RETAIL : 'Retail',
        PMPC : 'PMPC',
        PERMANENT : 'Permanent'
    };
    let INVITE_STATUS = {
        PENDING : 'ACCOUNT PENDING',
        COMPLETE : 'Complete'
    };


    let LOGGEDIN_KEY = 'loggedIn';
    let JWT_KEY = 'USER_PROFILE_JWT';
    let USER_PROFILE_MIN__KEY = 'USER_PROFILE_MIN_INFO';
    let USER_PROFILE_MASTER__KEY = 'USER_PROFILE_MASTER_INFO';
    let GIGYA_DETAILS_KEY = 'GIGYA_DETAILS';
    let RETURN_URL_KEY = 'PAGE_RETURN_URL';
    let SPONSOR_RETURN_URL_KEY = 'SPONSOR_RETURN_URL_KEY';
    let INVITE_URL_KEY = 'INVITE_RETURN_URL';
    let SIGNUP_USER_TYPE = 'SGUP_ROLE_USER';
    let CUST_TO_IND_DIST_RET_PAGE = 'CUST_TO_IND_DIST_RET_PAGE';
    let HOST_INFO = 'HOST_INFO';
    let GUID = 'GUID';
    let UUID = 'UUID';
    let UNAME_KEY = 'uname';

    let getUserProfileMasterInfo = function(){
        let data = cookieUtil.getCookie(USER_PROFILE_MASTER__KEY);
        if(null != data && undefined != data && 0 < data.length){
            return JSON.parse(cookieUtil.getCookie(USER_PROFILE_MASTER__KEY));
        }else{
            return null;
        }

    };

    return {
        USER_ROLE: USER_ROLE,
        USER_TYPE: USER_TYPE,
        CUST_CLASS: CUST_CLASS,
        INVITE_STATUS: INVITE_STATUS,
        LEGACY_USER_TYPE:LEGACY_USER_TYPE,
        // *******************
        // Changed from this.determineUserType
        determinUserType : function (userData){
            let userType = null;
            if(userData['customerClass']){
                if(userData['customerClass'] === CUST_CLASS.RETAIL){
                    userType = USER_TYPE.RETAIL_CUSTOMER
                }else if(userData['customerClass'] === CUST_CLASS.PMPC){
                    userType = USER_TYPE.PREFERED_CUSTOMER
                }else if(userData['customerClass'] === CUST_CLASS.PERMANENT){
                    if(userData['userRole'] === USER_ROLE.PRIMARY){
                        userType = USER_TYPE.PRIMARY_DISTRIBUTOR;
                    }else if(userData['userRole'] === USER_ROLE.ASSOCIATE){
                        userType = USER_TYPE.ASSOCIATE;
                    }else if(userData['userRole'] === USER_ROLE.FAMILY_MEMBER){
                        userType = USER_TYPE.FAMILY_MEMBER;
                    }
                }
            }
            return userType;
        },

        // *************************************
        // ************ New Services ***********
        setUserProfileNew:function(loginData, accountData){
            let jwt =  loginData.eid;
            let userProfileMinInfo = this.transformPersonInfo(loginData);

            // ***** set cookies *********
            cookieUtil.setCookie(JWT_KEY, JSON.stringify(jwt));
            localStorage.setItem(USER_PROFILE_MIN__KEY, JSON.stringify(accountData));
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMinInfo));
        },

        transformPersonInfo: function(data) {
            let userData = {
                "accountId":data.person.sapID,
                "accountType":"Individual",
                "emailId":data.person.email,
                "emailVerified":false,
                "gigyaId":data.person.gigyaUID,
                "userId":data.person.personID.toLowerCase(),
                "userRole":"Primary",
                "userType":"Primary_Distributor",
                "username": ""
            };

            //  data.account.header.accountType;
            // emailId data.contactInfo.email

            // userRole
            if(data.person.type == LEGACY_USER_ROLE.ASSOCIATE) {
                userData.userRole = USER_ROLE.ASSOCIATE;
            } else if(data.person.type == LEGACY_USER_ROLE.PRIMARY) {
                userData.userRole = USER_ROLE.PRIMARY;
            }

            const custType = data.account.customerType;
            // userType
            if(custType == LEGACY_USER_TYPE.PRIMARY_DISTRIBUTOR) {
                if(data.person.type == LEGACY_USER_ROLE.ASSOCIATE) {
                    userData.userType = USER_TYPE.ASSOCIATE;
                } else {
                    userData.userType = USER_TYPE.PRIMARY_DISTRIBUTOR;
                }
            } else if (
                custType == LEGACY_USER_TYPE.PREFERED_CUSTOMER 
                || custType == LEGACY_USER_TYPE.PREFERED_CUSTOMER_ALT
            ) {
                userData.userType = USER_TYPE.PREFERED_CUSTOMER;
            } else if (custType == LEGACY_USER_TYPE.RETAIL_CUSTOMER) {
                userData.userType = USER_TYPE.RETAIL_CUSTOMER;
            }
            let uname = cookieUtil.getCookie(UNAME_KEY);
            if(null != uname && undefined != uname && 0 < uname.length){
                userData.username = uname;
            }

            return userData;
        },

        // *************************************

        setUserProfile: function (loginData, accountData, gigyaObj) {
            let jwt = loginData.eid;
            let userProfileMasterInfo = this.transformPersonInfo(loginData);
            let userProfileMinInfo=this.transformMinInfo(accountData);

            // ***** set cookies *********
            cookieUtil.setCookie(GIGYA_DETAILS_KEY, JSON.stringify(gigyaObj));
            cookieUtil.setCookie(JWT_KEY, JSON.stringify(jwt));
            localStorage.setItem(USER_PROFILE_MIN__KEY, JSON.stringify(userProfileMinInfo));
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMasterInfo));
            cookieUtil.setCookie(LOGGEDIN_KEY, true);
            this.storeUserInfo(loginData);
        },


        transformMinInfo: function(data) {
            let minData={};

            if(data.profileThumbnailUrl) {
                minData.profileCommPreferences ={
                    "gender":"",
                    "languagePreferences":data.preferredLanguage,
                    "marketingEmail":true
                };
                minData.profileContactInfo = {
                    "email":data.email
                };
                minData.profileHeader ={
                    "accountId":data.sapID,
                    "firstName":data.firstName,
                    "lastName":data.lastName,
                    "profileThumbnailUrl":data.profileThumbnailUrl,
                    "preferredName":data.preferredName,
                    "userId":data.personID
                };
                minData.profilePersonalInfo = {
                    "gender":"",
                    "personalId":data.personID
                };
                minData.profileSponsorDetails = {
                    "id":data.sponsorID,
                    "country":"",
                    "names":{
                        "default":""
                    }};


                minData.profilePrivacyOptionInfo = {
                    "acceptMarketingEmail":true,
                    "acceptMarketingSMS":false,
                    "contactPreference":"EMAIL",
                    "showContactInfo":false,
                    "showContactInfoToFamilyAndFriends":false,
                    "showContactInfoToFirstUpLine":false,
                    "visibleInScannerLocator":false,
                    "visibleInSponsorSearch":false
                };

            } else {

                try {
                    minData.profileCommPreferences = {
                        gender: data.person.gender,
                        languagePreferences: data.person.preferredLanguage,
                        marketingEmail: data.person.preferences.acceptMarketingEmail
                    };
                    minData.profileContactInfo = {
                        email: data.person.email
                    };
                    minData.profileHeader = {
                        accountId: data.person.accountID,
                        firstName: data.person.names.local.given,
                        lastName: data.person.names.local.family,
                        profileThumbnailUrl: data.person.profileThumbnailUrl,
                        preferredName: data.person.preferredName,
                        userId: data.person.id
                    };
                    minData.profilePersonalInfo = {
                        gender: data.person.gender,
                        personalId: data.person.id
                    };
                    minData.profileSponsorDetails = data.sponsor;
                    minData.profilePrivacyOptionInfo = data.person.preferences;
                } catch (exception) { //eslint-disable-line no-empty
                }
            }
            return minData;
        },

        getAccountType: function() {
            let custType = '';
            try {
                custType = getUserProfileMasterInfo().userType;
            } catch(e) { custType = ''; }

            if (custType == 'Primary_Distributor' || custType == 'Associate') {
                return "10";
            } else if (custType == 'Retail_Customer') {
                return "20";
            } else if (custType == 'Prefered_Customer') {
                return "30";
            } else {
                return "0";
            }
        },

        setAccountType: function(custType) {
            if (custType == 'DIST' || custType == 'DISTRIBUTOR') {
                return "10";
            } else if (custType == 'CUST' || custType == 'CUSTOMER') {
                return "20";
            } else if (custType == 'PREF' || custType == 'PREFERREDCUST' || custType == 'PREFERRED') {
                return "30";
            } else {
                return "0";
            }
        },

        getCustomerType: function(custType) {
            if (custType == 'DIST') {
                return "DISTRIBUTOR";
            } else if (custType == 'CUST') {
                return "CUSTOMER";
            } else if (custType == 'PREF' || custType == 'PREFERRED') {
                return "PREFERREDCUST";
            } else {
                return "";
            }
        },

        storeUserInfo: function (userData) {
            let loginTime = new Date().getTime(),
                resultObject = {user:{
                    "id": userData.account.id,
                    "name": userData.person.localName,
                    "localName": userData.person.localName,
                    "email": userData.person.email,
                    "accountType": this.setAccountType(userData.account.customerType),
                    "countryCd": userData.country,
                    "priceType": userData.account.priceType,
                    "customerType": this.getCustomerType(userData.account.customerType),
                    "eid": userData.eid,
                    "lastName": userData.person.lastName,
                    "firstName": userData.person.firstName,
                    "loginTime": loginTime
                }};

            localStorage.setItem("nuskin.account.data", JSON.stringify(resultObject));
        },

        deleteUserProfile:function(){
            cookieUtil.setCookie(JWT_KEY, "", -1);
            localStorage.removeItem(USER_PROFILE_MIN__KEY);
            cookieUtil.setCookie(USER_PROFILE_MIN__KEY, '', -1); // this will need to be removed eventualy
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, "", -1);
            cookieUtil.setCookie(RETURN_URL_KEY, "", -1);
            cookieUtil.setCookie(SIGNUP_USER_TYPE, "", -1);
            cookieUtil.setCookie(GIGYA_DETAILS_KEY, "", -1);
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, "", -1);
            cookieUtil.setCookie(GUID, "", -1);
            cookieUtil.setCookie(UUID, "", -1);
            cookieUtil.setCookie(HOST_INFO, "", -1);
            cookieUtil.setCookie(LOGGEDIN_KEY, "", -1);
        },

        logoutButKeepHostData: function() {
            // keeping SIGNUP_USER_TYPE, GUID, UUID, HOST_INFO
            cookieUtil.setCookie(JWT_KEY, '', -1);
            localStorage.removeItem(USER_PROFILE_MIN__KEY);
            cookieUtil.setCookie(USER_PROFILE_MIN__KEY, '', -1); // this will need to be removed eventualy
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, '', -1);
            cookieUtil.setCookie(RETURN_URL_KEY, '', -1);
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, '', -1);
            cookieUtil.setCookie(LOGGEDIN_KEY, '', -1);
            cookieUtil.setCookie('cart_guid', '', -1);
            try {
                gigya.accounts.logout({
                    forceProvidersLogout: true
                });
            } catch(e) {}
        },

        getJWT : function(){
            let jwt = cookieUtil.getCookie(JWT_KEY);
            if(null != jwt && undefined != jwt && 0 < jwt.length){
                return JSON.parse(cookieUtil.getCookie(JWT_KEY));
            }else{
                return null;
            }

        },
        getUserProfileDetailInfo : function(){
            let data = localStorage.getItem(USER_PROFILE_MIN__KEY);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(data);
            }else{
                return null;
            }

        },
        setUserProfileDetailInfo : function(userProfileMinInfo){
            localStorage.setItem(USER_PROFILE_MIN__KEY, JSON.stringify(userProfileMinInfo));
        },
        getGigyaDetails : function(){
            let data = cookieUtil.getCookie(GIGYA_DETAILS_KEY);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(GIGYA_DETAILS_KEY));
            }else{
                return null;
            }

        },
        setGigyaDetails : function(gigyaDetails){
            cookieUtil.setCookie(GIGYA_DETAILS_KEY, JSON.stringify(gigyaDetails));
        },

        getUserProfileMasterInfo : getUserProfileMasterInfo,

        setUserProfileMasterInfo : function(userProfileMasterInfo){
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMasterInfo));
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getHostInfo()
         * @returns {boolean}
         */
        getHostInfo : function(){
            let data = cookieUtil.getCookie(HOST_INFO);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(HOST_INFO));
            }else{
                return null;
            }

        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.isUserLoggedIn()
         * @returns {boolean}
         */
        isUserLoggedIn : function(){
            let jwt = this.getJWT();
            if(null != jwt && undefined != jwt && 0 < jwt.length && this.isSignInMandatoryCookiesPresent()){
                return true;
            }
            return false;
        },
        setPageReturnURL : function(url){
            cookieUtil.setCookie(RETURN_URL_KEY, JSON.stringify(url));
        },
        getPageReturnURL : function(){
            let data = cookieUtil.getCookie(RETURN_URL_KEY);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(RETURN_URL_KEY));
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setInviteUrl(url)
         * @param {string} url
         */
        setInviteUrl : function(url){
            cookieUtil.setCookie(INVITE_URL_KEY, JSON.stringify(url));
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getInviteUrl()
         * @param {string} url
         */
        getInviteUrl : function(){
            let data = cookieUtil.getCookie(INVITE_URL_KEY);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(INVITE_URL_KEY));
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setCustomerConvertionReturnURL(url)
         * @param {string} url
         */
        setCustomerConvertionReturnURL : function(url){
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, JSON.stringify(url));
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getCustomerConvertionReturnURL()
         * @returns {string} url
         */
        getCustomerConvertionReturnURL : function(){
            let data = cookieUtil.getCookie(CUST_TO_IND_DIST_RET_PAGE);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(CUST_TO_IND_DIST_RET_PAGE));
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setSignUpUserType(role)
         * @param {string} role
         */
        setSignUpUserType: function(role){
            cookieUtil.setCookie(SIGNUP_USER_TYPE, role);
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getSignUpUserType()
         * @returns {string} role
         */
        getSignUpUserType: function(){
            let data = cookieUtil.getCookie(SIGNUP_USER_TYPE);
            if(null != data && undefined != data && 0 < data.length){
                return cookieUtil.getCookie(SIGNUP_USER_TYPE);
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setGuid(guid)
         * @param {string} guid
         */
        setGuid: function(guid){
            cookieUtil.setCookie(GUID, guid);
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getGuid()
         * @param {string} guid
         */
        getGuid: function(){
            let data = cookieUtil.getCookie(GUID);
            if(null != data && undefined != data && 0 < data.length){
                return cookieUtil.getCookie(GUID);
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setUUID(uuid)
         * @param {string} uuid
         */
        setUUID: function(uuid){
            cookieUtil.setCookie(UUID, uuid);
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getUUID()
         * @param {string} uuid
         */
        getUUID: function(){
            let data = cookieUtil.getCookie(UUID);
            if(null != data && undefined != data && 0 < data.length){
                return cookieUtil.getCookie(UUID);
            }else{
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.setSponsorPageReturnURL(url)
         * @param {string} url
         */
        setSponsorPageReturnURL : function(url){
            cookieUtil.setCookie(SPONSOR_RETURN_URL_KEY, JSON.stringify(url));
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getSponsorPageReturnURL()
         * @returns {string} url
         */
        getSponsorPageReturnURL : function(){
            let data = cookieUtil.getCookie(SPONSOR_RETURN_URL_KEY);
            if(null != data && undefined != data && 0 < data.length){
                return JSON.parse(cookieUtil.getCookie(SPONSOR_RETURN_URL_KEY));
            }else{
                return null;
            }
        },
        setPageLocaleVal: function(data){
            storage(storage.metadata.LANGUAGE, data.language);
            storage(storage.metadata.MARKET, data.market);
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getPageLocaleVal(data)
         * @returns {object} locale
         */
        getPageLocaleVal: function() {
            let languageVal= storage(storage.metadata.LANGUAGE);
            let marketVal= storage(storage.metadata.MARKET);
            if (!!languageVal && !!marketVal) {
                return {
                    language: storage(storage.metadata.LANGUAGE),
                    market: storage(storage.metadata.MARKET)
                };
            } else {
                return null;
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getJWTKey()
         * @returns {string} jwtKey
         */
        getJWTKey: function(){
            return JWT_KEY;
        },

        //###### CHANGED for refactoring
        //deleteUserProfileCookiesAndSignOut: function(actionDesc,index, isOpenInNewWindow){
        //    var URL = angular.element($('#'+actionDesc+index)).val();

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.deleteUserProfileCookiesAndSignOut(URL,isOpenInNewWindow)
         * @param {string} url
         * @param {boolean} isOpenInNewWindow
         */
        deleteUserProfileCookiesAndSignOut: function(URL,isOpenInNewWindow){
            userProfileManager.deleteUserProfile();
            cookieUtil.setCookie('cart_guid',"",-1);
            gigya.accounts.logout({
                forceProvidersLogout : true
            });

            if(URL){
                if(isOpenInNewWindow){
                    window.open(URL);
                }else{
                    window.location = window.location.protocol+'//'+window.location.host+ URL + '.html';
                }
            }
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.isMandatoryInfoAvailable(hybrisResponse)
         * @param {object} hybrisResponse
         */
        isMandatoryInfoAvailable: function(hybrisResponse){

            let isMandatoryInfoPresent = false;
            let userData = hybrisResponse.userData;

            console.log(userData);
            if(this.isAccountInfoMissing(userData) && this.isUserInfoMissing(userData)){

                isMandatoryInfoPresent = true;
            }

            return isMandatoryInfoPresent;

        },

        isAccountInfoMissing: function({accountId, emailId, alphaAccount}){
            return exists(accountId) && exists(emailId) && alphaAccount;
        },

        isUserInfoMissing: function({userId, userRole, customerClass}){
            return exists(userId) && exists(userRole) && exists(customerClass);
        },

        /**
         * @memberof userProfileManager
         * @example
         * userProfileManager.getProfileImageReference()
         * @returns {string} profileImageRef
         */
        getProfileImageReference :  function (){
            let profileImageRef = "";
            profileImageRef = document.getElementById('profileImageReferencePath').value;
            return profileImageRef;

        },

        isSignInMandatoryCookiesPresent :  function (){

            let gigyaDetails = this.getGigyaDetails();
            let userProfileMaster = getUserProfileMasterInfo();
            let userProfileMiniInfo = this.getUserProfileDetailInfo();

            if(!!gigyaDetails && !!userProfileMaster && !!userProfileMiniInfo){
                return true;
            }
            else{
                return false;
            }

        },

        redirectUserToSprinkrAssetSharePage : function(socialAssetShareURL) {
            let sprinklrURL = sprinklrBaseURL;
            window.location.href = sprinklrURL+socialAssetShareURL;
        },

        returnUserMarket : function() {
            let userProfileInfo = getUserProfileMasterInfo();
            let userMarket = userProfileInfo.accountId.substr(0,2);
            if (userMarket == 'UK' || userMarket == 'uk') {
                userMarket = 'GB';
            }
            if (userMarket == 'AS' || userMarket == 'as') {
                userMarket = 'AU';
            }
            return userMarket;
        }
    }
})();

export default userProfileManager;

/**
 * Utility function. shorthand for comparing null and undefined.
 * 
 * If you use == instead of ===, v == null is the same as v === null || v === undefined.
 * @param {*} v value to check
 * @return if v is not null or undefined
 */
function exists(v) {
    return v != null;
}
